import { QueryParamProvider } from "@mgdx/shared/src/providers/QueryParamProvider";
import { TalkStoreProvider } from "@mgdx/talk/providers/TalkStoreProvider";
import { VideoCallingStoreProvider } from "@mgdx/video-calling/providers/VideoCallingStoreProvider";
import { ErrorBoundary, errorHandlerReport, initSentry } from "@mgdx-libs/error-handler";
import { globalHistory, Location } from "@mgdx-libs/router";
import { QueryClientProvider } from "@tanstack/react-query";
import type { GatsbyBrowser, GatsbySSR } from "gatsby";
import React, { type PropsWithChildren } from "react";
import Helmet from "react-helmet";

import { App } from "./App";
import { AuthProvider } from "./AuthProvider";
import { useFocusAndBlurObserver } from "./hooks/useFocusAndBlurObserver";
import { queryClient } from "./queryClient";
import { talkStore, videoCallingStore } from "./stores/sharedStores";

initSentry({ dsn: process.env.SENTRY_DSN });

const RootElement = ({ children }: PropsWithChildren<EmptyObject>) => {
  useFocusAndBlurObserver();

  return (
    <ErrorBoundary errorHandlerReport={errorHandlerReport}>
      <Location>
        {({ location }) => (
          <QueryParamProvider location={location} reachHistory={globalHistory}>
            <QueryClientProvider client={queryClient}>
              <Helmet>
                <html lang="ja" />
                <title>薬急便</title>
                <meta
                  name="viewport"
                  content="width=device-width,initial-scale=1,shrink-to-fit=no,viewport-fit=cover"
                />
              </Helmet>
              <TalkStoreProvider store={talkStore}>
                <VideoCallingStoreProvider store={videoCallingStore}>
                  <AuthProvider>
                    <App>{children}</App>
                  </AuthProvider>
                </VideoCallingStoreProvider>
              </TalkStoreProvider>
            </QueryClientProvider>
          </QueryParamProvider>
        )}
      </Location>
    </ErrorBoundary>
  );
};

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] & GatsbySSR["wrapRootElement"] = ({ element }) => (
  <RootElement>{element}</RootElement>
);
